<template>
  <div>
    <div
      id="submitResultsModal"
      class="modal fade"
      tabindex="-1"
      role="dialog"
    >
      <div
        class="modal-dialog"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              Submit results
            </h4>
          </div>
          <div class="modal-body">
            <p><b>Finally, we would like to ask a few questions about yourself. None of these questions will identify who you are.</b></p>
            <p>
              In what capacity are you responding?
            </p>
            <div class="form-group">
              <select
                v-model="individualOrBusiness"
                class="form-control"
              >
                <option value="Individual">
                  An interested individual
                </option>
                <option value="Business">
                  On behalf of a business
                </option>
                <option value="Interest">
                  A special interest group
                </option>
              </select>
            </div>

            <template v-if="individualOrBusiness === 'Individual'">
              <p>
                What type of job do you have?
              </p>
              <div class="form-group">
                <select
                  v-model="job"
                  class="form-control"
                >
                  <option value="EMPTY">
                    Choose one
                  </option>
                  <option value="EMPTY">
                    - - -
                  </option>
                  <option value="Managerial/Professional">
                    Managerial/Professional
                  </option>
                  <option value="Skilled Manual">
                    Skilled Manual
                  </option>
                  <option value="Unskilled Manual">
                    Unskilled Manual
                  </option>
                  <option value="Education">
                    Education
                  </option>
                  <option value="Other">
                    Other
                  </option>
                </select>
              </div>
            </template>

            <template v-if="individualOrBusiness === 'Business'">
              <p>
                What sector is your business in?
              </p>
              <div class="form-group">
                <select
                  v-model="businessType"
                  class="form-control"
                >
                  <option value="EMPTY">
                    Choose one
                  </option>
                  <option value="EMPTY">
                    - - -
                  </option>
                  <option value="Professional Services">
                    Professional Services
                  </option>
                  <option value="Manufacturing">
                    Manufacturing
                  </option>
                  <option value="Farming/Food Production">
                    Farming/Food Production
                  </option>
                  <option value="Logistics">
                    Logistics
                  </option>
                  <option value="Education/Academia">
                    Education/Academia
                  </option>
                  <option value="Public Sector">
                    Public Sector
                  </option>
                  <option value="Health">
                    Health
                  </option>
                  <option value="Other">
                    Other
                  </option>
                </select>
              </div>
            </template>

            <template v-if="individualOrBusiness === 'Interest'">
              <p>
                Please indicate the name of the group
              </p>
              <div class="form-group">
                <input
                  v-model="groupName"
                  type="text"
                  class="form-control"
                  placeholder="Name of the special interest group"
                >
              </div>
            </template>

            <p>
              Please provide the first part of the post code of either where you live or where your business is located
            </p>
            <div class="form-group">
              <input
                v-model="postcode"
                type="text"
                class="form-control"
                placeholder="First part of the postcode, e.g. CV10"
              >
            </div>

            <p>
              Please indicate your age
            </p>
            <div class="form-group">
              <select
                v-model="age"
                class="form-control"
              >
                <option value="EMPTY">
                  Choose one
                </option>
                <option value="EMPTY">
                  - - -
                </option>
                <option value="Under 15">
                  Under 15
                </option>
                <option value="15-20">
                  15-20
                </option>
                <option value="21-39">
                  21-39
                </option>
                <option value="40-59">
                  40-59
                </option>
                <option value="60+">
                  60+
                </option>
              </select>
            </div>

            <p>
              Pre-COVID, how often did you use public transport (bus or train)?
            </p>
            <div class="form-group">
              <select
                v-model="publicTransport"
                class="form-control"
              >
                <option value="EMPTY">
                  Choose one
                </option>
                <option value="EMPTY">
                  - - -
                </option>
                <option value="More than once a week">
                  More than once a week
                </option>
                <option value="Around once a week">
                  Around once a week
                </option>
                <option value="One to two times a month">
                  One to two times a month
                </option>
                <option value="Less frequently">
                  Less frequently
                </option>
              </select>
            </div>

            <p>
              Pre-COVID, roughly how many miles did you dive in your car every year
            </p>
            <div class="form-group">
              <select
                v-model="driving"
                class="form-control"
              >
                <option value="EMPTY">
                  Choose one
                </option>
                <option value="EMPTY">
                  - - -
                </option>
                <option value="Never, I don't own a car">
                  Never, I don't own a car
                </option>
                <option value="Less than 5,000 miles">
                  Less than 5,000 miles
                </option>
                <option value="Between 5 and 10,000 miles">
                  Between 5 and 10,000 miles
                </option>
                <option value="Between 10 and 20,000 miles">
                  Between 10 and 20,000 miles
                </option>
                <option value="Over 20,000 miles">
                  Over 20,000 miles
                </option>
              </select>
            </div>

            <br>
            &nbsp;
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-link"
              data-dismiss="modal"
            >
              Close without saving
            </button>
            <button
              type="button"
              class="btn btn-primary"
              :disabled="isRunning"
              @click="sendToMidlands()"
            >
              <template v-if="isRunning">
                <span class="glyphicon glyphicon-refresh spinning" />
              </template>
              Save &amp; submit
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiHandler from "../../services/ApiHandler";
import * as $ from "jquery";
import "bootstrap";

export default {
  data() {
    return {
      sharedStorage: this.$root.$data.sharedStorage,
      currentRun: this.$root.$data.sharedStorage.getCurrentRun(),
      isRunning: false,
      // Values to be sent to MCSIM
      individualOrBusiness: "Individual",
      businessType: null,
      groupName: null,
      job: null,
      postcode: null,
      age: null,
      publicTransport: null,
      driving: null,
    };
  },
  created() {
    this.$root.$data.eventHub.$on(
      "show-submit-results-modal",
      this.displayModal
    );
  },
  methods: {
    displayModal: function () {
      $("#submitResultsModal").modal("show");
    },
    async sendToMidlands() {
      this.isRunning = true;
      const data = this.currentRun.getInputVariables();

      const customerForm = {
        individualOrBusiness: this.individualOrBusiness,
        businessType: this.businessType,
        groupName: this.groupName,
        job: this.job,
        postcode: this.postcode,
        age: this.age,
        publicTransport: this.publicTransport,
        driving: this.driving,
      };

      const { error } = await apiHandler.storeData({
        dataJson: {
          customerForm,
          choices: data,
        },
      });
      if (error) {
        alert(error);
      } else {
        alert("Successfully saved");
      }
      this.isRunning = false;

      this.saveResult();
    },
    saveResult() {
      this.sharedStorage.saveRun({
        name: `Run on ${new Date().toLocaleString()}`,
      });
      this.sharedStorage.startNewRun();
      document.location.href = "/";
    },
  },
};
</script>

<style lang="scss">
.modal-body p {
  margin: 20px 0;
}
#submitResultsModal .modal-dialog {
  width: 750px;
}
</style>
